<div class="tabs-container">
  <div class="tabs-header" role="tablist">
    @for (tab of tabsNames; track tab; let i = $index) {
      <div
        class="tab-title"
        [class.active]="activeTab === i"
        (click)="selectTab(i)"
        (keydown.enter)="selectTab(i)"
        (keydown.space)="selectTab(i); $event.preventDefault()"
        [attr.tabindex]="0"
        role="tab"
        [attr.aria-selected]="activeTab === i"
        [attr.aria-controls]="'tab-panel-' + i"
        [id]="'tab-' + i"
      >
        {{ tab }}
      </div>
    }
  </div>

  <div
    class="tabs-content bg-white px-24 py-24"
    role="tabpanel"
    [attr.aria-labelledby]="'tab-' + activeTab"
    [id]="'tab-panel-' + activeTab"
  >
    <ng-content></ng-content>
  </div>
</div>
